import { render, staticRenderFns } from "./DashboardOrder.vue?vue&type=template&id=7bf586e8&"
import script from "./DashboardOrder.vue?vue&type=script&lang=ts&"
export * from "./DashboardOrder.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardOrder.vue?vue&type=style&index=0&id=7bf586e8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports